<!-- 总数 -->
<template>
    <div class='count-wrapper'>
        <div class="box tongjititlerow">
            <div class="iconfont icon-tongji tongji"></div>
            <div class="title">街道概况</div>
        </div>
        <div class="box num-wrapper">
            <div class="row">
                <div>已注册/总人口</div>
                <div class="box blue"><div>{{peopleCount}}</div><div class="small">人</div></div>
            </div>
            <div class="row">
                <div>社区活动</div>
                <div class="box blue"><div>{{activityCount}}</div><div class="small">个</div></div>
            </div>
        </div>
        <div class="box num-wrapper">
            <div class="row">
                <div>已注册/党员</div>
                <div class="box blue"><div>{{dyCount}}</div><div class="small">人</div></div>
            </div>
            <div class="row">
                <div>事件上报</div>
                <div class="box blue"><div>{{eventCount}}</div><div class="small">件</div></div>
            </div>
        </div>
        <div class="box num-wrapper">
            <div class="row">
                <div>企业</div>
                <div class="box blue"><div>{{companyCount}}</div><div class="small">个</div></div>
            </div>
            <div class="row">
                <div>待办事件</div>
                <div class="box yellow"><div>{{todoCount}}</div><div class="small">件</div></div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            peopleCount:0,
            activityCount:0,
            dyCount:0,
            eventCount:0,
            companyCount:0,
            todoCount:0,
        };
    },
  props:{
    token:{
      type:String,
      default: ''
    }
  },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            var url = this.urlobj.systemCount

            this.$get(url,{},{
              token:this.token || this.$store.state.access_token
            }).then(res => {
                if (res.isSucceed) {
                    let data = new Array(11).fill(0)
                    res.rows.forEach(item => {
                        switch(item.name){
                            case '已注册居民':
                               data[0]=item.countNum;
                               break;
                            case '居民总人口':
                               data[1]=item.countNum>10000?(parseFloat(item.countNum)/10000).toFixed(2)+'万':item.countNum;
                               break;
                            case '已注册党员':
                               data[2]=item.countNum;
                               break;
                            case '党员总人口':
                               data[3]=item.countNum>10000?(parseFloat(item.countNum)/10000).toFixed(2)+'万':item.countNum;
                               break;
                            case '已注册企业':
                               data[4]=item.countNum;
                               break;
                            case '活动总数':
                               data[5]=item.countNum;
                               break;
                            case '事件总数':
                               data[6]=item.countNum;
                               break;
                            case '事件办理总数':
                               data[7]=item.countNum;
                               break;
                            case '今日活动':
                               data[8]=item.countNum;
                               break;
                            case '今日事件':
                               data[9]=item.countNum;
                               break;
                            case '今日待办':
                               data[10]=item.countNum;
                               break;
                        }
                    });
                    this.peopleCount=data[0]+'/'+data[1];
                    this.activityCount=data[5];
                    this.dyCount=data[2]+'/'+data[3];
                    this.eventCount=data[6];
                    this.companyCount=data[4];
                    this.todoCount=data[10];
                } else {

                }
            }).catch(e => {

            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getData()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
  .wrapper{

  }
//@import url(); 引入公共css类
.tongjititlerow{
    margin-top: 20px;
  align-items: center;
}
.title{
    font-size: 16px;
    color:#b0b0b0;
}
.row{
    display: flex;
    height: 40px;
    width: 245px;
    padding:0 20px;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(136, 171, 218,.2);
    font-size: 16px;
    color:#b0b0b0;
    margin-left: 15px;
    margin-top:10px;
}
.tongji{
    color: #02fe99;
    font-size: 16px;
    margin: 0 5px 0 15px;
}
.blue{
    color:#00daff;
    align-items: baseline;
}
.yellow{
    color:#feb500;
    align-items: baseline;
}
.small{
    font-size: 12px;
}
</style>
